export function getBackendBaseUrl() {
  const raw =
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    'https://bxi-backend-development-pqauh.ondigitalocean.app';
  return String(raw).replace(/\/+$/, '');
}

/** Base URL with trailing slash (for axios.defaults.baseURL). */
export function getApiBaseUrl() {
  return getBackendBaseUrl() + "/";
}

/** Base URL for /api/v1 routes (for v1Backend axios instance). */
export function getApiV1BaseUrl() {
  return getBackendBaseUrl() + "/api/v1/";
}

export function getBxiApiKey() {
  const key = process.env.REACT_APP_BXI_API_KEY;
  if (!key) {
    throw new Error(
      "REACT_APP_BXI_API_KEY is not set. Configure it in the build environment; " +
        "there is no hardcoded fallback.",
    );
  }
  return key;
}

export default getBackendBaseUrl;
